import * as actions from './subscriptionActions';

const subscriptionReducers = {
  [actions.STORE_SUBSCRIPTIONS_DATA]: (state, { payload }) => {
    state.notifications = { ...state.notifications, ...payload };
    return { ...state };
  },
};

export default subscriptionReducers;
